import React from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import CheckUnauthorizedQuery from './AccessToQuery';
import { createDateObject } from '../../../Helpers/dateFormatter';

type result = {
  loading: boolean;
  error?: ApolloError;
  authorized?: boolean;
};

interface IAccessToConnectorApollo {
  children: (result: result) => React.ReactElement;
}

const isUnauthorized = (accessTo?: string | null) => {
  if (accessTo !== undefined && accessTo !== null) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const accessToDate = createDateObject(accessTo);

    if (accessToDate === null) return true;
    return accessToDate < today;
  }

  return true;
};

const AccessToConnectorApollo: React.FC<IAccessToConnectorApollo> = ({ children }) => {
  const { loading, error, data, refetch } = useQuery(CheckUnauthorizedQuery);

  const result: result = {
    loading,
    error,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    const unauthorized = isUnauthorized(data?.me.diet.accessTo);
    result.authorized = !unauthorized;

    if (unauthorized) {
      refetch();
    }
  }

  return children(result);
};

export default AccessToConnectorApollo;
